import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';
import { ControlRotator } from './index';

export default class ControlRotatorFitting extends ControlRotator {
  /**
     * Translateのアップデート
     */
  updateTranslate() {
    // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    let sc: number = 1 / root.scaleX;

    // iPad・スマホは掴みやすくする
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      sc *= 2; // 2倍の大きさにする
    }

    // x,yについては、位置補正で使用している固定値6.5/25に対してのみスケールを適用する
    this.transformMatrix = `matrix(${sc},0,0,${sc},${
      this.x + 6.5 - (6.5 * sc)},${
      this.y + 25 - (25 * sc)})`;

    // this.transformMatrix = "matrix(1,0,0,1," + this.x + "," + this.y + ")";
    this.viewObj.setAttribute('transform', `rotate(180) ${this.transformMatrix}`);
  }
}
